import { EventEmitter, Injectable, signal, TemplateRef } from '@angular/core';
import { FeatureEnum, ReasonType } from 'src/app/core/graphql/generated/graphql';
// import { CreatePhoneOtpGQL, VerifyPhoneOtpGQL, GetReasonsGQL } from 'src/app/generated/graphql';
// BusinessPackageByBusinessIdGQL, ClearAllFilterGQL, CountriesGQL, GetEmployeeByEmailGQL,
import { AbstractControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, filter } from 'rxjs/operators';
import { BehaviorSubject, EMPTY, Observable, Subject, throwError } from 'rxjs';
import moment from 'moment';
import 'moment-timezone';
// import { LocalStoreService } from './local-store.service';
import { environment } from 'src/environments/environment';
// import { add } from 'ngx-bootstrap/chronos';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
// import { AuthModel } from 'src/app/modules/auth/models/auth.model';
// import { AuthService } from 'src/app/shared/services';
import { DatePipe } from '@angular/common';
import { LocalStoreService } from './local-store';
import { AuthService } from '@app/core/auth/auth.service';
import { VariableService } from './variable.service';
export interface BusinessDatePrefs {
  timeZone: string;
  dateFormat: string;
  timeFormat: string;
}


@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private authLocalStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`;
  featureEnum = { timesheet: FeatureEnum.Timesheet, scheduler: FeatureEnum.Schedule, task: FeatureEnum.Task, document: FeatureEnum.DocumentControl }

  private subject = new Subject<any>();
  private addEmp = new BehaviorSubject<any>('');

  private parent = new BehaviorSubject<boolean>(true);
  public parentdata = this.parent.asObservable();

  private chatCount = new BehaviorSubject<number>(0);
  public chatCountData = this.chatCount.asObservable();

  private setupTemplate = new BehaviorSubject<any>(null);
  public templateData = this.setupTemplate.asObservable();

  private discountData = new BehaviorSubject<any>(null);
  public discountData$ = this.discountData.asObservable();

  private notificationIdSource = new BehaviorSubject<string | null>(null);
  notificationId$ = this.notificationIdSource.asObservable();

  private sectionLoadingState = new BehaviorSubject<{ [key: string]: boolean }>({});
  sectionLoadingState$ = this.sectionLoadingState.asObservable();

  selectedDateFormat: string = 'MM/DD/YYYY';
  private bsConfig: any = {};
  public innerWidth: any;
  public innerHeight: any;
  public modalId: any;
  modalIds: any = [];
  selectedBusinessId: any = null;
  bsModalRef: any;
  openPopup: any
  itemId: any
  selectComponents: any;
  storeFormData: any = {};
  previousUrl = signal<string | null>(null);
  currentUrl = signal<string | null>(null);
  currentUrlSegment: string = '';
  public globalSearch: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    // private createPhoneOtpGQL: CreatePhoneOtpGQL,
    // private verifyPhoneOtpGQL: VerifyPhoneOtpGQL,
    // private countriesGQL: CountriesGQL,
    // private getEmployeeByEmailGQL: GetEmployeeByEmailGQL,
    // private getReasonGQL: GetReasonsGQL,
    public http: HttpClient,

    // private businessPackageByBusinessIdGQL: BusinessPackageByBusinessIdGQL,
    private ls: LocalStoreService,
    // private clearAllFilterGQL: ClearAllFilterGQL,
    private router: Router,
    private route: ActivatedRoute,
    private authSerive: AuthService,
    private datePipe: DatePipe,
    private vars: VariableService
  ) {
    this.initializeDateFormat();
    this.initializeBsConfig();
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.extractFirstSegment(event.urlAfterRedirects);
      this.previousUrl.set(this.currentUrl());
      this.currentUrl.set(event.urlAfterRedirects);
      if (event.url.includes('document-control')) {
        //for state: True
      }
      else {
        this.vars.setIsUserInDriveModule(false);
      }
    });
  }
  setNotificationId(id: string): void {
    this.notificationIdSource.next(id);
  }

  clearNotificationId(): void {
    this.notificationIdSource.next(null);
  }

  setLoadingState(sectionName: string, isLoading: boolean): void {
    const currentState = this.sectionLoadingState.getValue();
    if (currentState[sectionName] !== isLoading) {
      const updatedState = { ...currentState, [sectionName]: isLoading };
      this.sectionLoadingState.next(updatedState);
    }
  }

  delay(ms = 3000) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  navigateByQueryParams(route: any, params: any) {
    this.router?.navigate([route], { queryParams: params });
  }

  private extractFirstSegment(url: string): void {
    this.currentUrlSegment = url.split('/').filter(segment => segment)[0] || '';
  }

  getCurrentUrl() {
    return !['roles-permissions', 'update-role'].includes(this.currentUrlSegment);
  }

  sendClickEvent(data?: any) {
    this.subject.next(data);
  }
  getClickEvent(): Observable<any> {
    return this.subject.asObservable();
  }

  setNewValue(val: string) {
    this.addEmp.next(val);
  }

  getNewValue() {
    return this.addEmp.asObservable();
  }

  updateData(newValue: boolean) {
    this.parent.next(newValue);
  }

  updateChatCount(newValue: number) {
    this.chatCount.next(newValue);
  }


  updateTemplate(newValue: any) {
    this.setupTemplate.next(newValue);
  }

  updateDiscount(newValue: any) {
    this.discountData.next(newValue);
  }

  getAllCountries() {
    // return this.countriesGQL.watch().valueChanges;
  }

  async convertToImage(url: string, type: string = 'png', name: string = 'default') {
    return new Promise((resolve) => {
      var image = fetch(url)
        .then(function (res) {
          return res.arrayBuffer();
        })
        .then(function (buf) {
          return new File([buf], name + '.' + type, { type: type });
        });
      resolve(image);
    });
  }

  toDataURL = (url: string) =>
    fetch(url, {
      method: 'GET',
      headers: { 'Access-Control-Allow-Origin': '*' },
    })
      .then((response) => response.blob())
      .then(
        (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      );

  getCountries() {
    // return this.countriesGQL.watch().valueChanges;
  }

  getEmployeeByEmail(email: string) {
    // return this.getEmployeeByEmailGQL.watch({
    //   email: email,
    // }).valueChanges;
  }

  // custom validator to check that two fields match
  MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: UntypedFormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors['mustMatch']) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  getFileFromPost(url: string, data: any, global: boolean = true): any {
    url = environment.restURI + url;
    let token = this.authSerive.getToken();

    return this.http
      .post(url, data, {
        responseType: 'blob',
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }),
        // headers: new HttpHeaders().append('Content-Type', 'application/json'),
      })
      .pipe(
        catchError((err: any) => {
          if (err.status === 401) {
            return EMPTY;
          } else {
            return throwError(() => err);
          }
        })
      );
  }

  removeEmpty = (obj: any) => {
    Object.keys(obj).forEach((key) => {
      if (obj[key] == null || obj[key] == '') {
        delete obj[key];
      }
    });
    return obj;
  };

  getBusinessPackageByBusinessId(business: string) {
    // return this.businessPackageByBusinessIdGQL.watch({
    //   businessId: business,
    // }).valueChanges;
  }

  // transformTime(value) {
  //   let time = value.split(':');
  //   if(time[1] == undefined){
  //     time[1] = ''
  //   } if(time[0] == undefined){
  //     time[0] = ''
  //   }
  // if(time[0] > 23){
  //   let hours = time[0] = 23
  //   return hours + ':' + time[1]
  // } else if( time[1] > 59) {
  //   let mints = time[1] = 59
  //  return time[0] + ':' + mints
  // }
  //  else{
  //   return time[0] + ':' + time[1]
  // }
  // }

  //loop to increment the time and push results in array

  generateTime(checkTime: any[]): string[] {
    const interval = 1;
    let times: string[] = [];
    let startTime = 0;

    if (!checkTime || checkTime.length === 0) {
      for (let i = 0; startTime < 24 * 60; i++) {
        const hh = Math.floor(startTime / 60);
        const mm = startTime % 60;

        times[i] =
          ('0' + (hh % 24)).slice(-2) + ':' + ('0' + mm).slice(-2);

        startTime += interval;
      }
      return times;
    } else {
      return checkTime;
    }
  }
  private dataStoreTimeSheetPayload = 'dataStoreTimeSheet';
  setdataStoreTimeSheetPayload(data: any) {
    localStorage.setItem(this.dataStoreTimeSheetPayload, JSON.stringify(data));
  }


  generateOneHours() {
    let times = [];
    for (let i = 1; i <= 60; i++) {
      let minutes = i < 10 ? '0' + i : i; // Add leading zero for single digit minutes
      times.push({ value: i, name: `${minutes} min` });
    }
    return times;
  }

  schedulerMints: any;
  calculateWorkingHours(getStartTime: string, getEndTime: string) {
    let startTime = moment(getStartTime, 'HH:mm:ss a');
    let endTime = moment(getEndTime, 'HH:mm:ss a');
    let duration = moment.duration(endTime.diff(startTime));
    let milliseconds = duration.asMilliseconds();
    if (milliseconds < 0) {
      milliseconds = milliseconds + 86400000;
    }
    this.schedulerMints = milliseconds;
    let minutes = Math.floor((milliseconds / (1000 * 60)) % 60),
      hours = Math.floor((milliseconds / (1000 * 60 * 60)) % 24);
    if (hours <= 0 && minutes <= 0) {
      hours = hours + 24;
    }
    if (hours == 24) {
      minutes = 0;
    }
    return (
      hours.toString().padStart(2, '0') +
      ' H ' +
      minutes.toString().padStart(2, '0') +
      ' M'
    );
  }

  listingResize(event: Event) {
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
    if (this.innerWidth == 2400) {
      return 16;
    }
    if (this.innerWidth == 2133) {
      return 14;
    }
    if (this.innerWidth == 1920) {
      return 12;
    }
    if (this.innerWidth >= 3840) {
      return 27;
    }
    if (this.innerWidth == 3413) {
      return 24;
    }
    if (this.innerWidth == 3200) {
      return 22;
    }
    // 2732
    if (this.innerWidth == 2560 || this.innerWidth == 2880 || this.innerWidth == 2844) {
      return 19;
    }
    if (this.innerWidth == 1280) {
      return 12;
    }
    if (this.innerWidth == 1366) {
      return 7;
    }
    return 11;
  }

  // Roster employee acroding with
  scheduleResize(event: Event) {
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
    // && this.innerWidth < 2949
    if (

      this.innerWidth == 2400
    ) {
      return 14;
    }
    if (this.innerWidth == 2133) {
      return 11;
    }
    if (this.innerWidth == 1920) {
      return 10;
    }
    if (this.innerWidth >= 3840) {
      return 26;
    }
    if (this.innerWidth >= 3000 && this.innerWidth < 3840) {
      return 22;
    }
    // 2732
    if (this.innerWidth == 2560 || this.innerWidth == 2880 || this.innerWidth == 2844) {
      return 18;
    }
    if (this.innerWidth == 1280) {
      return 12;
    }
    if (this.innerWidth == 1366) {
      return 7;
    }
    return 10;
  }


  private idSource = new BehaviorSubject<string>('');
  currentId = this.idSource.asObservable();
  private idSource2 = new BehaviorSubject<string>('');
  currentId2 = this.idSource.asObservable();
  private _value: any;
  private _value2: any;


  getValue(): any {
    return this._value;
  }

  // Setter function
  setValue(newValue: any): void {
    this._value = newValue;
  }
  getValue2(): any {
    return this._value2;
  }

  // Setter function
  setValue2(newValue: any): void {
    this._value2 = newValue;
  }

  setSelectComponent(arr: any) {
    this.selectComponents = arr;
  }

  attachScrollEvent(modalBody: HTMLElement, selectComponents: any, dataPicker?: any, assign?: boolean) {
    modalBody?.addEventListener('scroll', () => {
      // if (selectComponents?.length) {//guard if obj is array
      //   selectComponents?.forEach((selectComponent: any) => {
      //     selectComponent?.close();
      //   });
      // }
      if (dataPicker) {
        dataPicker.hide();
      }
      this.closeAllSelects(selectComponents);
      this.closeAllSelects(this.selectComponents);
    });
  }

  closeAllSelects(arr: any[]) {
    if (arr?.length) {
      arr?.forEach((select: any) => {
        select?.close();
      });
    }
  }


  removeScrollEvent(modalBody: HTMLElement) {
    modalBody?.removeEventListener('scroll', this.scrollHandler);
  }

  scrollHandler(event: Event) {
  }
  formatDateTimeDifference(dateTimeString: string): string {
    const currentDate = new Date();
    const pastDate = new Date(dateTimeString);
    const timeDifference = currentDate.getTime() - pastDate.getTime();
    const minutesDifference = Math.round(timeDifference / (1000 * 60));

    if (minutesDifference < 1) {
      return 'Less than a minute ago';
    } else if (minutesDifference < 60) {
      return `${minutesDifference} minute${minutesDifference > 1 ? 's' : ''} ago`;
    } else if (minutesDifference < 1440) { // Less than 24 hours
      const hoursDifference = Math.floor(minutesDifference / 60);
      return `${hoursDifference} hour${hoursDifference > 1 ? 's' : ''} ago`;
    } else if (pastDate.getDate() === currentDate.getDate() - 1) {
      return 'Yesterday';
    } else {
      const formattedDate = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' }).format(pastDate);
      return formattedDate;
    }
  }


  clearAllFilter() {
    // return this.clearAllFilterGQL.mutate({});
  }


  findFirstInvalidInput(formContainer: any): HTMLElement {
    const formFields = formContainer?.nativeElement?.querySelectorAll('.ng-invalid');

    for (let i = 0; i < formFields?.length; i++) {
      const formField = formFields[i];

      if (formField.classList.contains('is-invalid') || formField.classList.contains('select-invalid')) {
        return formField;
      }
    }

    return null as unknown as HTMLElement;
  }

  private chartLevel: number = 1;

  getChartLevel(): any {
    return this.chartLevel;
  }
  setChartLevel(newValue: number): void {
    this.chartLevel = newValue;
  }
  private getAuthFromLocalStorage(): any | undefined {
    const lsValue = localStorage.getItem(this.authLocalStorageToken);
    if (!lsValue) {
      return undefined;
    }
    const authData = JSON.parse(lsValue);
    return authData;

  }

  getBareerToken() {
    const auth = this.getAuthFromLocalStorage();
    return auth.authToken;
  }

  checkFeatureHierarchy(type: string) {
    let featureHierarchyEmployee = this.authSerive.featureHierarchy().filter((ele: any) => ele.feature == 'manage_employee');
    let filterData = this.authSerive.featureHierarchy().filter((ele: any) => ele.feature == type);
    const employee = featureHierarchyEmployee[0];
    const timesheet = filterData[0];
    // Check if employeeData's is_all is true
    if (employee?.is_all) {
      return true;
    }
    // Check if is_peer for both employeeData and timesheetData are the same
    const isPeerSame = employee?.is_peer === timesheet?.is_peer;
    // Check if is_under_them for both employeeData and timesheetData are the same
    const isUnderThemSame = employee?.is_under_them === timesheet?.is_under_them;
    // Return true if both is_peer and is_under_them are the same, otherwise false
    return isPeerSame && isUnderThemSame;

  }
  initializeDateFormat(): void {
    const savedData = localStorage.getItem('dateformat');
    this.selectedDateFormat = (savedData && savedData !== 'null') ? savedData.replace(/^['"](.*)['"]$/, '$1') || 'MM/DD/YYYY' : this.selectedDateFormat = 'MM/DD/YYYY';
  }

  getDateFormat(): string {
    this.initializeDateFormat();
    this.initializeBsConfig();
    return this.selectedDateFormat;
  }

  get _getDateFormatOnly() {
  return this.selectedDateFormat;
}

getAngularDateFormat(): string {
  return this.getDateFormat()
    .replace(/YYYY/g, 'yyyy')
    .replace(/DD/g, 'dd')
    .replace(/YY/g, 'yy');
}

formatDateStringForCsv(value: string): string {
  const m = moment(value, moment.ISO_8601, true);
  return m.isValid() ? m.format(this.getDateFormat()) : value;
}
  // Initialize the bsConfig dynamically
  private initializeBsConfig(): void {
  this.bsConfig = {
    showWeekNumbers: false, // Hide week numbers
    dateInputFormat: this.selectedDateFormat, // Set the date format
  };
}
getBsConfig(): any {
  return this.bsConfig;
}

checkPermissons(requiredPermissions: string[], availablePermissions: string[]): boolean {
  return requiredPermissions.some(permission => availablePermissions.includes(permission));
}

zeroValidator(control: AbstractControl): ValidationErrors | null {
  const value = parseFloat(control.value);
  if (value === 0) {
    return { zero: true };
  }
  return null;
}

///for encryption and decryption purposes

/**
* Encode an object safely to Base64 => LOWER Level
* @param data - The object to encode
* @returns Base64 encoded string
*/
encodeObject(data: any): string {
  try {
    if (!data) return ''; // Handle empty data
    const jsonString = JSON.stringify(data);
    // let base64Encoded = btoa(unescape(encodeURIComponent(jsonString)));
    let base64Encoded = btoa(unescape(encodeURIComponent(JSON.stringify(data))));

    // Inject random strings at fixed positions
    // base64Encoded = base64Encoded.slice(0, 5) + 'XYZ' + base64Encoded.slice(5, 10) + 'ABC' + base64Encoded.slice(10);

    return base64Encoded;
  } catch (error) {
    return '';
  }
}

/** => LOWER Level
 * Decode a Base64 string back to an object
 * @param encodedData - The Base64 string
 * @returns Decoded object or null
 */
decodeObject<T>(encodedData: string): T | null {
  try {
    if (!encodedData) return null;

    // First decode the URL-encoded characters like %2B, %2F, %3D
    const urlDecoded = decodeURIComponent(encodedData);

    // Then decode from base64 to original JSON string
    const jsonString = decodeURIComponent(escape(window.atob(urlDecoded)));

    // Finally, parse JSON
    return JSON.parse(jsonString) as T;
  } catch (error) {
    return null;
  }
}
forRoute() {
  this.openPopup = this.route?.snapshot?.queryParamMap.get('openPopup');
  this.itemId = this.route?.snapshot?.queryParamMap.get('itemId');
}
forWindowClose() {
  this.forRoute();
  if (this.openPopup && this.itemId) {
    setTimeout(() => {
      window.close();
    }, 1000);
  }
}
forWindowUpdateClose() {
  this.forRoute();
  if (this.openPopup && this.itemId) {
    setTimeout(() => {
      window.close();
    }, 1500);
  }
  if (window.opener) {
    window.opener.location.reload();
  }
}


getAcceptedStatus(data: any[]): any[] {
  if (!Array.isArray(data)) {
    return [];
  }

  return data.filter(item => (item?.status === 'accepted' || item?.status === 'rejected'));
}

filterCount(filtersConfig: any[], filterOptionsList: any[]): number {
  const allFields: string[] = [];
  const hasConfig = Array.isArray(filtersConfig) && filtersConfig.length > 0;
  const hasOptions = Array.isArray(filterOptionsList) && filterOptionsList.length > 0;
  if (!hasConfig && !hasOptions) return 0;
  if (hasConfig) {
    filtersConfig.forEach(filter => {
      if (filter?.field && typeof filter.field === 'string' && filter.field.trim() !== '') {
        allFields.push(filter.field.trim());
      }
    });
  }
  if (hasOptions) {
    filterOptionsList.forEach(filter => {
      if (filter?.field && typeof filter.field === 'string' && filter.field.trim() !== '') {
        allFields.push(filter.field.trim());
      }
    });
  }
  const uniqueFields = new Set(allFields);
  return uniqueFields.size;
}


formatDateTimeWithPrefs() {
  let lsUser = this.storedUser;
  let timeZone = lsUser?.business_id?.time_zone ? lsUser?.business_id?.time_zone : 'America/New_York';
  let dateFormat = lsUser?.date_format ? lsUser?.date_format : 'MM/DD/YYYY';
  let timeFormat = !lsUser?.business_id?.is_24_hour_format ? 'hh:mm A' : 'HH:mm';
  return { timeZone, dateFormat, timeFormat };
}

getBusinessTimeZone(): string {
  let lsUser = this.ls?.user;
  let timeZone = lsUser?.business_id?.time_zone ? lsUser?.business_id?.time_zone : 'America/New_York';
  return timeZone || 'America/New_York';
}

toBusinessTimeZone(date: Date): moment.Moment {
  return moment.tz(date, this.getBusinessTimeZone());
}

toBusinessDateOnly(date: Date): any {
  // ✅ Allowed date formats
  const dateFormatMap: { [key: string]: string } = {
    'MM/DD/YYYY': 'MM/dd/yyyy',
    'DD/MM/YYYY': 'dd/MM/yyyy',
    'YYYY-MM-DD': 'yyyy-MM-dd',
    'DD-MM-YYYY': 'dd-MM-yyyy',
    'MM-DD-YYYY': 'MM-dd-yyyy',
    'DD-MMM-YY': 'dd-MMM-yy',
    'DD-MMMM-YYYY': 'dd-MMMM-yyyy'
  };

  const formatDate = this.formatDateTimeWithPrefs();
  const businessMoment = moment.utc(date).tz(formatDate.timeZone).startOf('day');
  const mappedFormat = dateFormatMap[formatDate.dateFormat] || 'yyyy-MM-dd';
  return moment(businessMoment.format(formatDate.dateFormat), formatDate.dateFormat).toDate();
}

dateFormatMap: { [key: string]: string } = {
  'MM/DD/YYYY': 'MM/DD/YYYY',
    'DD/MM/YYYY': 'DD/MM/YYYY',
      'YYYY-MM-DD': 'YYYY-MM-DD',
        'DD-MM-YYYY': 'DD-MM-YYYY',
          'MM-DD-YYYY': 'MM-DD-YYYY',
            'DD-MMM-YY': 'DD-MMM-YY',
              'DD-MMMM-YYYY': 'DD-MMMM-YYYY'
};

getTimeZoneWithFormatDate(date: Date): string | undefined {

  if (!date) {
    return;
  }
  const selectedAngularFormat = this.dateFormatMap[this.selectedDateFormat];
  return moment.tz(date, this.ls.user?.business_id?.time_zone).format(selectedAngularFormat)
}

  formatInBusinessTimeZone(value: string | Date): string {
    if (!value) return '';
    return moment.tz(value, this.getBusinessTimeZone()).toISOString();
  }

formatInBusinessDate(value: string | Date): Date | undefined {
  if (!value) {
    return;
  }
  const timeZone = this.getBusinessTimeZone();
  return moment.tz(value, timeZone).toDate();
}

dateFormatter(value: string | Date): string {
  if (!value) {
    return '';
  }
  return this.datePipe.transform(value, 'yyyy-MM-dd') || '';
}

businessDateFormatChangeApiCall(date: any) {
  if (!date) return null;

  let day = '';
  let month = '';
  let year = '';

  // Case 1: Date object
  if (date instanceof Date) {
    day = String(date.getDate()).padStart(2, '0');
    month = String(date.getMonth() + 1).padStart(2, '0');
    year = String(date.getFullYear());
    return `${year}-${month}-${day}`;
  }

  const inputDate = String(date);

  // Case 2: dd/MM/yyyy
  if (inputDate.includes('/')) {
    const parts = inputDate.split('/');
    if (parts.length === 3) {
      [day, month, year] = parts;
    }
  }

  // Case 3: yyyy-MM-dd
  else if (inputDate.includes('-')) {
    const parts = inputDate.split('-');
    if (parts.length === 3) {
      [year, month, day] = parts;
    }
  }

  // Case 4: other formats
  else {
    const d = new Date(inputDate);
    if (!isNaN(d.getTime())) {
      day = String(d.getDate()).padStart(2, '0');
      month = String(d.getMonth() + 1).padStart(2, '0');
      year = String(d.getFullYear());
      return `${year}-${month}-${day}`;
    }
  }

  // Final safety check
  if (day && month && year) {
    return `${year}-${month}-${day}`;
  }

  return null;
}

isUserHasPermission(feature: string, permission: string): boolean {
  return this.authSerive.isActionAllowed(feature, permission);
}

toLocalDateOnly(dateString: string): Date | null {
  if (!dateString) return null;
  const utcDate = new Date(dateString);
  return new Date(
    utcDate.getUTCFullYear(),
    utcDate.getUTCMonth(),
    utcDate.getUTCDate()
  );
}

getTimeZoneWithoutFormatDate(date: Date): string | undefined {
  if (!date) {
    return;
  }
  const selectedAngularFormat = this.dateFormatMap[this.selectedDateFormat];
  return moment.tz(date, this.ls.user?.business_id?.time_zone).format(selectedAngularFormat)
}


updateColumns(columns: any[]) {
  return columns
    .map(col => {
      if (col?.field === 'due_date') {
        return { ...col, field: 'completion_date', header: 'Completion Date' };
      }
      return col;
    })
    .filter(col => col?.field !== 'formatted_time');
}



  get storedUser(): any {
  try {
    const raw = localStorage.getItem('user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

getBusinessPrefs(): BusinessDatePrefs {
  const user = this.storedUser;
  const timeZone = user?.business_id?.time_zone
    || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const dateFormat = user?.date_format || user?.business_id?.date_format || 'MM/DD/YYYY';
  const timeFormat = user?.business_id?.is_24_hour_format ? 'HH:mm' : 'hh:mm A';
  return { timeZone, dateFormat, timeFormat };
}

formatDate(
  value: string | Date | null | undefined,
  type: 'date' | 'time' | 'datetime' = 'datetime',
): string {
  if (!value) return '';
  const { timeZone, dateFormat, timeFormat } = this.getBusinessPrefs();

  let format: string;
  switch (type) {
    case 'date': format = dateFormat; break;
    case 'time': format = timeFormat; break;
    case 'datetime': format = `${dateFormat} ${timeFormat}`; break;
  }
  return moment.tz(value, timeZone).format(format);
}

// For pure calendar dates (e.g. birth_date) — no timezone conversion
formatDateOnly(value: string | Date | null | undefined): string {
  if (!value) return '';
  const dateFormat = this.getDateFormat();
  let datePart: string;
  if (typeof value === 'string') {
    datePart = value.includes('T') ? value.split('T')[0] : value;
  } else {
    const yyyy = value.getFullYear();
    const mm = String(value.getMonth() + 1).padStart(2, '0');
    const dd = String(value.getDate()).padStart(2, '0');
    datePart = `${yyyy}-${mm}-${dd}`;
  }
  return moment(datePart, 'YYYY-MM-DD').format(dateFormat);
}

getCurrencySymbol(): string {
  const user = this.storedUser;
  console.log(user?.currency_symbol);
  console.log(user);

  return user?.currency_symbol ?? '';
}

getCurrencyFormat(): string {
  const user = this.storedUser;
  return user?.business_id?.currency_format ?? '';
}

}